export default __webpack_public_path__ + "static/media/dashboard-inactive.6e937f3f.svg";